/**
 * @workchat/shared-types/telemetry-endpoints — Frontend ↔ Backend telemetry endpoint URL SSOT.
 *
 * Cycle 47 — antipattern-frontend-telemetry-endpoint-silent-loss-without-route-handshake 의
 * layer 3 (Endpoint constant SSOT) 적용. cycle 46 의 endpoint hardcode 분산 봉합.
 *
 * 동기 (cycle 46 신규 학습 본문 발췌):
 *   "endpoint URL 을 단일 모듈에서 export — frontend 와 backend handler 가 같은 상수 import.
 *    monorepo 의 packages/shared-types 같은 위치가 적합. 별도 PR 에서 URL 만 변경해도 양쪽이
 *    동시 갱신."
 *
 * 사용:
 *   - frontend:  import { TELEMETRY_ERROR_ENDPOINT } from '@workchat/shared-types';
 *                fetch(TELEMETRY_ERROR_ENDPOINT, …)
 *   - backend:   import { TELEMETRY_ERROR_ENDPOINT } from '@workchat/shared-types';
 *                app.post(TELEMETRY_ERROR_ENDPOINT, …)
 *
 * 정책:
 *   - 모든 internal telemetry endpoint 는 본 모듈에서 한 번만 정의
 *   - `/api/v1` prefix 포함 — 양쪽이 절대 경로로 합의 (Vite proxy / Nginx try_files 와 충돌 방지)
 *   - 새 endpoint 추가 시 본 파일에 상수 + frontend + backend 양쪽 동시 commit
 */

/**
 * API v1 base prefix. backend fastify 라우트 정의 시 PATH 와 결합 → ENDPOINT.
 *   axios baseURL 사용 caller (apiClient) 는 PATH 만 쓰고,
 *   raw fetch caller (ErrorBoundary 의 telemetry.ts — apiClient 의 auth interceptor 우회 필요)
 *   는 ENDPOINT 사용.
 */
export const API_V1_PREFIX = '/api/v1' as const;

/** Cycle 27 — frontend ↔ backend trace_id mismatch batch 보고 (relative path — axios baseURL 결합용). */
export const TELEMETRY_TRACE_MISMATCH_PATH = '/internal/telemetry/trace-mismatch' as const;
/** Cycle 27 — absolute endpoint (backend fastify 등록 + raw fetch caller 용). */
export const TELEMETRY_TRACE_MISMATCH_ENDPOINT =
  `${API_V1_PREFIX}${TELEMETRY_TRACE_MISMATCH_PATH}` as const;

/** Cycle 46 — ErrorBoundary / window.onerror 등 frontend runtime error 보고 (relative). */
export const TELEMETRY_ERROR_PATH = '/internal/telemetry/error' as const;
/** Cycle 46 — absolute endpoint. */
export const TELEMETRY_ERROR_ENDPOINT =
  `${API_V1_PREFIX}${TELEMETRY_ERROR_PATH}` as const;
